export enum EPdfLogoTarget {
  ACCOUNT = 'account',
  SITE = 'site',
}
